export default {
  updateInProcessList(state, payload) {
    state.inProcessList = payload
  },
  updateSuccessList(state, payload) {
    state.successList = payload
  },
  updateFailedList(state, payload) {
    state.failedList = payload
  },
  updateCategoryList(state, payload) {
    state.categoryList = payload
  },
  updatePlatformList(state, payload) {
    state.platformList = payload
  },
  updateBizoppDetail(state, payload) {
    state.details = Object.assign(state.details, payload)
  },
  updateHomeList(state, payload) {
    state.homeList = payload
  },
  updateHomeListAll(state, payload) {
    state.homeListAll = payload
  },
  updateHomeListPriority(state, payload) {
    state.homeListPriority = payload
  },
  updateSalesNameData(state, payload) {
    state.salesNameData = payload
  },
  // 销售姓名选中数量
  updateSalesNameNum(state, payload) {
    state.salesNameNum = payload
  },
  updateStrategyTag(state, payload) {
    state.strategyTagData = payload
  },
  // 销售姓名面包屑层级
  updateBreadCrumbList(state, payload) {
    if (payload) {
      state.breadCrumbList.push(payload)
    } else {
      state.breadCrumbList = []
    }
  },
  // 销售姓名选择面包屑
  updateBreadCrumbChange(state, payload) {
    if (payload.index !== state.breadCrumbList.length - 1) {
      state.breadCrumbList.splice(
        state.breadCrumbList.indexOf(payload.value) + 1
      )
    }
  },
  updateHomeFilter(state, payload) {
    state.homeFilter = payload
  },
  updateHomeListPageNo(state, payload) {
    state.homeListPageNo = payload
  },
  updateHomeListAllPageNo(state, payload) {
    state.homeListAllPageNo = payload
  },
  updateHomeListPriorityPageNo(state, payload) {
    state.homeListPriorityPageNo = payload
  },
  updateHomeFilterNum(state, payload) {
    let { name, num } = payload
    state['selectNum' + name] = num
  },
  updateBizoppFromListById(state, payload) {
    const shopList = state.homeListAll.shopList
    for (let i = 0; i < shopList.length; i++) {
      if (shopList[i].shopId === payload.shopId) {
        state.homeListAll.shopList[i].newButton = payload.newButton
        return
      }
    }
  },
  updateActiveTab(state, data) {
    state.activeTab = data
  },

  // 改变状态
  changeShopZIndex(state, data) {
    state.changeZIndex = data
  },
  // 更新诊断
  updateDiagnosis(state, data) {
    state.diagnosis = Object.assign(
      {},
      {
        [data.shopId]: data.data
      }
    )
  },
  // 搜索历史
  updateHistory(state, data) {
    console.log(data)
    state.changeHistory = data
  },
  updateFirstEnterList(state, payload) {
    state.firstEnterList = payload
  }
}
